export default "__VITE_ASSET__jUpPfqwh__"